import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse,
} from '@angular/common/http';
import { catchError, switchMap, from, Observable, throwError } from 'rxjs';

@Injectable()
export class HttpErrorDecodeInterceptor implements HttpInterceptor {
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error?.error instanceof Blob) {
                    return from(error.error.text()).pipe(
                        switchMap((text) =>
                            throwError(() => ({
                                ...error,
                                error: JSON.parse(text),
                            })),
                        ),
                    );
                }

                throw error;
            }),
        );
    }
}
